import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { COLORS, SPACING, TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(productInformationStyles, {
    container: {
        gap: 10,
        css: css`
            width: 100%;
            padding: ${SPACING.standard} ${SPACING.standard} 0 ${SPACING.standard};
        `,
    },
    descriptionStyles: {
        productDetailLink: {
            css: css`
                width: 100%;
                span {
                    color: ${COLORS.text.base};
                    font-weight: ${TYPOGRAPHY.weight.black};
                }
            `,
            typographyProps: {
                size: 20,
            },
        },
    },
});
